import HolidayEvent from './HolidayEvent';
import TimeOffRequestEvent from './TimeOffRequestEvent';

class CalendarEventFactory {
  constructor(event) {
    switch (event.extendedProps.type) {
      case 'time_off_request':
        return new TimeOffRequestEvent(event);
      case 'holiday':
        return new HolidayEvent(event);
      default:
        throw new Error(`Type ${event.extendedProps.type} is not supported.`);
    }
  }
}

export default CalendarEventFactory;
